import type { ExpenseChecklistItem } from "../components/uangJalanReports/ExpenseChecklist";
import {
  ORDER_EXPENSE_TYPE_LABEL_KEYS,
  buildExpenseReviewKey,
  formatOrderRoute,
  normalizeSingletonExpenses,
  type Order,
  type SingletonOrderExpenseType,
} from "../types/order";
import { getExpenseReview } from "./embeddedExpenseReview";
import { normalizeAmount } from "./formatRupiah";

type TranslationKeys = string;

const STANDARD_LABEL_KEYS = ORDER_EXPENSE_TYPE_LABEL_KEYS;

export const buildOrderExpenseChecklistItems = (
  order: Order,
  t: (key: TranslationKeys) => string,
): ExpenseChecklistItem[] => {
  const items: ExpenseChecklistItem[] = [];

  for (const line of normalizeSingletonExpenses(order.expenses ?? [])) {
    if (line.type === "additional" && !line.id) {
      continue;
    }

    const key = buildExpenseReviewKey(line);
    const review = getExpenseReview(line);

    if (line.type === "additional") {
      const item: ExpenseChecklistItem = {
        key,
        label: line.notes || "",
        amount: normalizeAmount(line.amount),
        isAdditional: true,
        checked: review.checked,
        needsRevision: review.needsRevision,
      };
      if (line.overrideAmount !== undefined && line.overrideAmount !== null) {
        item.overrideAmount = normalizeAmount(line.overrideAmount);
      }
      items.push(item);
      continue;
    }

    const item: ExpenseChecklistItem = {
      key,
      label: t(STANDARD_LABEL_KEYS[line.type as SingletonOrderExpenseType]),
      amount: normalizeAmount(line.amount),
      detail:
        line.type === "mob" && normalizeAmount(line.amount) > 0 && order.expenseMobRoute?.length
          ? formatOrderRoute(order.expenseMobRoute)
          : undefined,
      checked: review.checked,
      needsRevision: review.needsRevision,
    };
    if (line.overrideAmount !== undefined && line.overrideAmount !== null) {
      item.overrideAmount = normalizeAmount(line.overrideAmount);
    }
    items.push(item);
  }

  return items;
};
